import {createFileRoute, Link} from '@tanstack/react-router'
import {getAPI} from "../../../api/api";
import {News} from "../../../models/news";
import React from "react";
import {FormattedDate} from "../../../components/generic/date";
import {HStack, Text} from "@chakra-ui/react";
import {ProfileLink} from "../../../components/users/profileLink";
import {useTranslation} from "../../../utils/helpers";
import Markdown from "react-markdown";
import {ROUTES} from "../../../constants";

export const Route = createFileRoute('/_site/news/index/$id')({
    component: () => {
        const {news} = Route.useLoaderData();
        const {t} = useTranslation("news");

        return <>
            <h2><FormattedDate date={news.date} />{" "}&ndash;{" "}{news.title}</h2>
            <Text variant={"article"}>
                <Markdown>{news.text}</Markdown>
            </Text>
            <HStack mt={4} textAlign={"right"} gap={4} justifyContent={"space-between"}>
                <Link to={ROUTES.NEWS_ARCHIVE}>{t("News archive")}</Link>
                <p>{t("Published by:")} <ProfileLink user={news.author} /></p>
            </HStack>
        </>
    },
    params: {
        parse: (params) => {
            return {
                id: parseInt(params.id)
            }
        },
        stringify: (params) => {
            return {
                id: params.id?.toString()
            }
        }
    },
    loader: async ({context, params}) => {
        const api = getAPI(context);
        const resp = await api.get<News>(`/api/v2/news/${params.id}`);
        return {
            news: resp.data
        };
    }
});
